/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');

  if (!!data.message) {
    alert(data.message);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/

ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {

  let formData = new FormData(form);
  let addonIncluded = false;
  let itemData = {};
  let addons = document.querySelectorAll('[name="addon"]');

  if(addons.length > 0){

      let items = [];
      let properties = {}
      let id;
      let quantity;
      let totalQuantity = 0;

      for(addon of addons){
        const properties = { "_badges": addon.dataset.metafields }
          let addonItem = {'id': addon.value,
            'quantity': 1,
            'properties': properties
            }
          totalQuantity++;
          items.push(addonItem);

      }

      for (const [key, value] of formData) {
          if(key === "id[]" || key === "id"){
               id = value;
          }else if(key === "quantity"){
               quantity = parseInt(value)
               totalQuantity++
          }else if(key.includes("properties")){

              let formattedKey = key.replace('properties[', "")
              let finalKey = formattedKey.replace(']',"")
              properties[finalKey] = value
          }
      }

      let formItem = {
          'id': id,
          'quantity': quantity,
          'properties': properties
      }

      items.push(formItem)
      itemData.items = items
  }else{
    itemData = $(form).serialize();
  }

  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: itemData,
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };

  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true,
      addOnIncluded      : false
    };
    

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);


    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {

      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    // $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    if(settings.addOnIncluded === true){

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');
      let form = document.querySelector('.js-add-to-cart-form');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      //Open mini cart
      // setTimeout(function() {

      // }, 1500);
      ShopifyAPI.addItemFromForm(form, itemAddedCallback, itemErrorCallback);
    }else{
      $formContainer.on('submit', function(evt) {

        evt.preventDefault();
        // Add class to be styled if desired
        $addToCart.removeClass('is-added').addClass('is-adding');

        // Remove any previous quantity errors
        $('.qty-error').remove();

        //Open mini cart
        // setTimeout(function() {

        // }, 1500);
        ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
      });
    }
  };

  itemAddedCallback = function (product) {
    setTimeout(function() {
      $addToCart.removeClass('is-adding').addClass('is-added').delay(10000).queue(function(rvt) {
        $addToCart.removeClass('is-added');
        //Close mini cart
        //document.getElementById('cartToggle').click();
        rvt();
      });
      if(('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)){
        window.location.href = '/cart';
      }else{
        document.getElementById('cartToggle').click();
        document.getElementById('cartDropDown').focus();
      }
      //$('#GoToCheckout').css('display', 'block');
    }, 1500);
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval(`(${XMLHttpRequest.responseText})`);
    $addToCart.removeClass('is-adding is-added');
    if (!!data.message) {

      if (data.status == 422) {
        $addToCart.addClass('disabled is-soldout').prop('disabled', true);
        $('.product-switcher').after('<div class="errors qty-error button-text">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      var data = {},
          source = $("#CartEmptyTemplate").html(),
          template = Handlebars.compile(source);
      $cartContainer.append(template(data));
      $cartContainer.next().addClass('hidden')
      cartCallback(cart);
      return;
    } else {
      $cartContainer.next().removeClass('hidden')
    }


    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */

      if (cartItem.properties._custom_image != null) {
        // Maybe not needed if the JS returns the cart-transformed image from the function.
        var prodImg = cartItem.properties._custom_image.replace(/(\.[^.]*)$/, "_x150_crop_center$1").replace('http:', '');
      } else if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_x150_crop_center$1").replace('http:', '');
      } else {
        var prodImg = `//eustore.hermanmiller.com/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_medium.gif`
      }

      var originalPrice = cartItem.original_price/100
      var salePrice = cartItem.final_price/100
      var salePercentage = 0
      if(salePrice < originalPrice){
        salePercentage = Math.round(((originalPrice-salePrice)/originalPrice) * 100)
      }

      var badgeText = ''
      if (cartItem?.properties?._badges) {
        var badges = cartItem.properties._badges
        if (badges.includes(cartItem.variant_id)) {
          var badgesArray = badges.split(',')
          badgesArray.forEach( badge => {
            if (badge.includes(cartItem.variant_id)) {
              badgeText = badge.split(':')[1]
            }
        })
      }
    }

      // Create item's data object and add to 'items' array
      if(cartItem.options_with_values[0].name != 'Title'){
        item = {
          key: cartItem.key,
          keynocolon: cartItem.key.replace(':', ''),
          line: index + 1, // Shopify uses a 1+ index in the API
          url: cartItem.url,
          img: prodImg,
          name: cartItem.product_title.split("*")[0],
          variation: cartItem.variant_title,
          variants: cartItem.options_with_values,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          itemInventory: cartItem?.properties?._inventoryQuantity,
          price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
          vendor: cartItem.vendor,
          linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
          originalPrice: Shopify.formatMoney(cartItem.original_price, settings.moneyFormat),
          finalPrice: Shopify.formatMoney(cartItem.final_price, settings.moneyFormat),
          finalLinePrice: Shopify.formatMoney(cartItem.final_line_price, settings.moneyFormat),
          originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
          discounts: cartItem.discounts,
          discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
          discountPercentage: salePercentage,
          discountBadge: badgeText
        };
      }else{
         item = {
          key: cartItem.key,
          keynocolon: cartItem.key.replace(':', ''),
          line: index + 1, // Shopify uses a 1+ index in the API
          url: cartItem.url,
          img: prodImg,
          name: cartItem.product_title.split("*")[0],
          variation: cartItem.variant_title,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          inventory: cartItem.properties.inventory_quantity,
          price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
          vendor: cartItem.vendor,
          linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
          finalPrice: Shopify.formatMoney(cartItem.final_price, settings.moneyFormat),
          finalLinePrice: Shopify.formatMoney(cartItem.final_line_price, settings.moneyFormat),
          originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
          discounts: cartItem.discounts,
          discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
          discountPercentage: salePercentage,
          discountBadge: badgeText
        };
      }


      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      cartCount: cart.item_count,
      cartTitle: cart.item_count > 1 ? "Items Added to Basket" : "Item Added to Basket",
      subTotalPrice: Shopify.formatMoney(cart.items_subtotal_price, settings.moneyFormat),
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscountMoney: cart.total_discount === 0 ? 0 :Shopify.formatMoney(cart.total_discount, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }

    });

    $body.on('click', '.ajaxcart__remove-adjust', function(e) {
      e.preventDefault();
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = 0;

      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();


        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]:not([data-skip-qty-js])');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = parseInt($el.val()),
            inputName = $el.attr('name'),
            inputId = $el.attr('id'),
            inputMax = $el.data().max,
            inputInventory = $el.data().inventory;

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty,
            disabledMinus = 'enabled',
            disabledAdd = 'enabled';

        if(currentQty === 1) {
          disabledMinus = 'disabled';
        }

        if (inputMax === 'exceeded' || inputInventory && currentQty >= inputInventory) {
          disabledAdd = 'disabled'
        }

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId,
              disabledMinus: disabledMinus,
              disabledAdd: disabledAdd
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }else{

    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));

document.addEventListener("DOMContentLoaded", () => {
    Handlebars.registerHelper('startsWith', function(arg1, arg2, options) {
        return (arg1.startsWith(arg2)) ? options.fn(this) : options.inverse(this);
    });
    Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
        return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
    });
    Handlebars.registerHelper('unlessEquals', function(arg1, arg2, options) {
        return (arg1 != arg2) ? options.fn(this) : options.inverse(this);
    });

    ajaxCart.init({
      formSelector: '#addToCartForm',
      cartContainer: '#cartContainer',
      addToCartSelector: '#addToCart',
      cartCountSelector: '.cartCount',
      cartCostSelector: '#cartCost',
      moneyFormat: Shopify.moneyFormat
    });
    ajaxCart.load();
  })
